import axios from "axios";
import { api } from "../lib";
import type { QcNotice, QcReview } from "../types/qcReview";

export const qcReviewService = {
  queue: (page: number) =>
    api.get<{
      items: Array<{
        id: string;
        caseNumber: string;
        patient?: { firstName: string; lastName: string };
      }>;
      total: number;
      page: number;
    }>(`/workflows/qc-review?page=${page}`),
  read: (caseId: string) => api.get<QcReview>(`/workflows/qc-review/${caseId}`),
  command: async (
    review: QcReview,
    slide?: { slideId: string; expectedDone: boolean; desiredDone: boolean }
  ) => {
    try {
      return await api.post(`/workflows/qc-review/${review.id}/commands`, {
        requestId: crypto.randomUUID(),
        expectedAssignmentRevision: review.assignmentRevision,
        expectedQcRevision: review.qcRevision,
        ...slide,
      });
    } catch (error) {
      if (axios.isAxiosError(error) && error.response?.status === 409)
        throw new Error(
          "QC review changed or rework is still outstanding. The current review has been loaded."
        );
      if (axios.isAxiosError(error) && error.response?.status === 403)
        throw new Error("You do not have permission to change this QC review.");
      throw new Error(
        "QC review could not be saved. Your slides remain available."
      );
    }
  },
  notices: () =>
    api.get<{ data: QcNotice[]; unreadCount: number }>(
      "/notifications/qc-failures"
    ),
  markRead: (id: string) =>
    api.patch<QcNotice>(`/notifications/qc-failures/${id}/read`),
};
